import {
  addHours,
  addDays,
  addMonths,
  subDays,
  subYears,
  addYears,
  subHours,
  subMonths,
  endOfDay,
} from "date-fns";

/*
 Date object to string in format 'dd/mm/yyyy', or original input if not a Date object
 */
export const dateObjectToString = (d: Date | any): string =>
  d instanceof Date
    ? [d.getDate(), d.getMonth() + 1, d.getFullYear()]
        .map(n => (n < 10 ? `0${n}` : `${n}`))
        .join("/")
    : d;

/*
 UTC Date string to string in format 'dd/mm/yyyy' or original input if not a string

"2020-01-27T14:05:31.117"  ==> "27/01/2020"
 */

export const formatUTCDateString = (d: string): string => {
  let date = d.split("T")[0].split("-");
  return date[2] + "/" + date[1] + "/" + date[0];
};

export type TimeInterval =
  | "24 hrs"
  | "3 days"
  | "1 week"
  | "1 month"
  | "1 year";
export const getDateRange = (date: Date, interval: TimeInterval) => {
  let dateFrom: Date;
  let dateTo: Date;

  switch (interval) {
    case "24 hrs":
      dateFrom = subHours(date, 24);
      dateTo = addHours(date, 24);
      break;
    case "3 days":
      dateFrom = subDays(date, 3);
      dateTo = addDays(date, 3);
      break;
    case "1 week":
      dateFrom = subDays(date, 7);
      dateTo = addDays(date, 7);
      break;
    case "1 month":
      dateFrom = subMonths(date, 1);
      dateTo = addMonths(date, 1);
      break;
    case "1 year":
      dateFrom = subYears(date, 1);
      dateTo = addYears(date, 1);
      break;
    default:
      dateFrom = subYears(date, 10);
      dateTo = endOfDay(date);
  }

  return [{ DateFrom: dateFrom.toISOString(), DateTo: dateTo.toISOString() }];
};
